<template>
  <div class="not-found">
    <h1> <span>404</span> Page Not Found</h1>
    <router-link to="/" class="themeBtn btn fs20 rounded-pill h60">Go to Home</router-link>
  </div>
</template>